import { useLocation } from 'react-router';

import { OppByTaskTypeChart } from '../../charts/OppByTaskChart';
import { TotalTaskOppChart } from '../../charts/TotalTaskOppChart';
import {
  getHygieneOpportunity,
  getHygieneOpportunityByTask,
} from '../../helpers/hygieneOpportunity';
import type { THygieneRegionRates } from '../../types';
import { RegionHeader } from '../RegionHeader';

import { HygieneRegionTable } from './HygieneRegionTable';

export const RegionHygiene = ({
  hygieneRegionRates,
}: {
  hygieneRegionRates?: THygieneRegionRates[];
}) => {
  const location = useLocation();
  const id = location.pathname.split('region/')[1]?.split('/')[0];

  const hygieneRegion = hygieneRegionRates?.find(
    (region) => region.regionId === id,
  );

  const totalHygieneOpportunity = getHygieneOpportunity(hygieneRegion);
  const hygieneOpportunityByTask = getHygieneOpportunityByTask(hygieneRegion);

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-px-8 vai-py-4">
      <RegionHeader />

      <div className="vai-flex vai-flex-row vai-gap-4">
        <TotalTaskOppChart totalOpp={totalHygieneOpportunity} />
        <OppByTaskTypeChart opportunityByTask={hygieneOpportunityByTask} />
      </div>
      <HygieneRegionTable practices={hygieneRegion?.practices} />
    </div>
  );
};
